
interface HeroSectionProps {
  language: 'es' | 'en';
}

export default function HeroSection({ language }: HeroSectionProps) {
  const content = {
    es: {
      title: 'Tu primer paso en Japón, acompañado 🇯🇵',
      subtitle: 'Acompañamiento completo en tus primeros trámites, residencia y vida práctica en Japón.',
      cta: 'Agendá tu asesoría',
      newBeginning: 'Your new beginning'
    },
    en: {
      title: 'Your new beginning in Japan 🇯🇵',
      subtitle: 'Complete support for your first procedures, residence and practical life in Japan.',
      cta: 'Book your consultation',
      newBeginning: 'Tu primer paso en Japón'
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(211, 47, 47, 0.7), rgba(211, 47, 47, 0.5)), url('https://public.readdy.ai/ai/img_res/7389d581cab471b64deb226d25ed69d4.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            {content[language].title}
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl mb-8 text-white/90 leading-relaxed max-w-3xl mx-auto">
            {content[language].subtitle}
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="bg-yellow-500 hover:bg-yellow-400 text-red-900 font-bold py-4 px-8 rounded-full text-lg transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
          >
            {content[language].cta}
          </button>

          {/* Decorative Elements */}
          <div className="mt-12 flex justify-center space-x-8 text-4xl">
            <span className="animate-bounce">🏯</span>
            <span className="animate-bounce" style={{ animationDelay: '0.2s' }}>🌸</span>
            <span className="animate-bounce" style={{ animationDelay: '0.4s' }}>⛩️</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
